/** FuryBot — Market Pulse Flow (Live VIX + Market Conditions) */
import axios from "axios";
import { track } from "../utils/analytics";
import { API } from "@/utils/constants";

const ZONE_MAP = {
  extreme_fear: {
    tone: "Volatility is extremely high right now",
    detail: "Markets are under significant stress. Drawdowns can hit faster than usual during high-fear periods. Consider reducing position sizes or waiting for conditions to calm.",
  },
  fear: {
    tone: "Volatility is elevated",
    detail: "Markets are showing above-average movement. Wider stops may be needed, and drawdown risk is higher than normal. Stay disciplined with your risk management.",
  },
  neutral: {
    tone: "Markets are in a normal range",
    detail: "Conditions are typical \u2014 neither unusually calm nor volatile. Standard risk management applies.",
  },
  greed: {
    tone: "Markets are calm today",
    detail: "Lower volatility usually means slower, more predictable moves. Good conditions for patient evaluation trading.",
  },
  extreme_greed: {
    tone: "Markets are very calm",
    detail: "Extremely low volatility can mean slower progress on evaluations, but also less risk of sudden drawdown spikes. Steady conditions for building consistency.",
  },
};

const FOLLOW_UPS = [
  { label: "Practice discipline", action: "link", data: "/do-not-trade" },
  { label: "Drawdown Visualizer", action: "link", data: "/drawdown-calculator" },
  { label: "Find low-risk firms", action: "link", data: "/prop-firms-low-drawdown" },
  { label: "Compare firms", action: "flow_compare" },
  { label: "Main menu", action: "home" },
];

export function createMarketPulseHandlers(ctx) {
  const { addBot } = ctx;

  const startMarketPulse = async () => {
    track("flow_started", { flow: "market_pulse" });
    addBot("Checking current market conditions...", []);

    try {
      const { data } = await axios.get(`${API}/market/vix`, { timeout: 8000 });
      const zone = ZONE_MAP[data.zone] || ZONE_MAP.neutral;
      const dir = data.change >= 0 ? "+" : "";

      const lines = [
        `**Market Pulse**\n`,
        `**${zone.tone}**\n`,
        `VIX: **${data.current}** (${dir}${data.change} / ${dir}${data.change_pct}% today)`,
        `Zone: ${data.label}\n`,
        `${zone.detail}\n`,
        `_Informational only \u2014 not trading advice. Use this as context for your own risk management._`,
      ];

      addBot(lines.join("\n"), FOLLOW_UPS);
    } catch {
      addBot("Market data is loading \u2014 you can still explore tools or firms below.\n\n_Check back in a moment, or use the tools to prepare for your next trade._", FOLLOW_UPS);
    }
  };

  return { startMarketPulse };
}
